import React from 'react';
import styled from 'styled-components';
import { java, bondiBlue } from '../Colors/Colors';
import { TextStyles } from './Text';
import { FocusRing } from '@react-aria/focus';

const noop = () => undefined;

function hreflessOnClick() {
  let delegate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  return e => {
    const result = delegate(e);

    if (typeof result != 'undefined') {
      return result;
    }

    e.preventDefault();
    return false;
  };
}

const Anchor = _ref => {
  let { ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FocusRing, {
    focusRingClass: "focus-ring"
  }, /*#__PURE__*/React.createElement(StyledAnchor, props));
};

const StyledAnchor = /*#__PURE__*/styled.a.attrs(props => ({ ...props,
  // no href, fallback to the "#"
  href: props.href || '#',
  // if we have an href we'll apply any onClick we are given. but if there is no href, then we are going to use
  // our hrefless onClick which basically just prevents the browser from performing it's default function which would
  // normally in this scenario just update the url's hash to just "#"
  onClick: props.href ? props.onClick : hreflessOnClick(props.onClick)
})).withConfig({
  displayName: "Anchor__StyledAnchor",
  componentId: "sc-sesgvh-0"
})(["color:", ";text-decoration:none;cursor:pointer;background:transparent;border:0;border-radius:4px;", " &:hover,&:focus,&:active{color:", ";}&:focus{box-shadow:0 0 10px -1px ", ";}&:active{box-shadow:0 0 5px -1px ", ";}&&&.focus-ring{outline:2px solid ", ";outline-offset:2px;}"], java, TextStyles, bondiBlue, java, bondiBlue, _ref2 => {
  var _theme$action;

  let {
    theme
  } = _ref2;
  return (theme === null || theme === void 0 ? void 0 : (_theme$action = theme.action) === null || _theme$action === void 0 ? void 0 : _theme$action.default) || java;
});
/** @component */

export default Anchor;